import Plans from './components/Plans';
export default Plans;